module.exports = __webpack_public_path__ + "static/slack-connect-channel-c9ef16b7528b82712fd6a1048c901975.png";